import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
// table-next
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import BoostrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { PageOptionsPvNx } from "../../components/PageParams";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AiOutlineCheck, AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";
import ConfirmDialog, { GetConfirmTitle } from "../../components/ConfirmDialog";
import { GetCreateTable } from "../../../core/Helper2";
export default function BranchPatientRight() {
  const userDetail = useSelector((state) => state.user.detail);
  const [mainright, setMainRight] = useState([]);
  const [brchright, setBrchRight] = useState([]);
  const [rowsEdited, setRowsEdited] = useState([]);
  const [selectedMain, setSelectedMain] = useState(null);
  const [showSaveOk, setShowSaveOk] = useState(false);

  // Confirm Dialog
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);

  const dispatch = useDispatch();

  // -----------------------------------------------
  useEffect(() => {
    // ** CLEAR SELECTED ROWS ***
    setRowsEdited([]);
    axios
      .post(
        process.env.REACT_APP_API + "api/patient-rights/list-data",
        {
          ItemInfo: {},
          UserInfo: userDetail,
        },
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data) {
          setMainRight(res.data.rows);
        }
      })
      .catch((err) =>
        dispatch(setReminder({ show: true, message: err.message }))
      );
    // refreshBranchRight();
  }, []);

  // -----------------------------------------------
  const refreshBranchRight = (row) => {
    if (rowsEdited.length > 0) {
      setRowsEdited([]);
    }

    // console.log("old ...................... ");
    // console.log(selectedMain);
    setSelectedMain(row);
    axios
      .post(
        process.env.REACT_APP_API + "api/patient-rights/get-branch-short",
        {
          SearchInfo: { patrightid: row.patrightid },
          UserInfo: userDetail,
        },
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data) {
          setBrchRight(res.data.rows);
        }
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  // ----------- INSERT NEW RIGHT -------------------------
  const insertNewRight = (row) => {
    if (row == null) {
      dispatch(
        setReminder({ show: true, message: "ยังไม่ได้เลือกแถว", type: "error" })
      );
    }

    axios
      .post(
        process.env.REACT_APP_API + "api/branch-patient-right/insert-new-right",
        {
          ItemInfo: row,
          UserInfo: userDetail,
        },
        HttpJsonHeader
      )
      .then((res) => {
        refreshBranchRight(row);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  // ---------------------------------------------
  const getHeaderStyle = (wi) => {
    return {
      width: wi,
      background: "var(--table-header-back-color)",
    };
  };
  // ---------------------------------------------
  const customTextFilter = {
    placeholder: "...",
  };
  // ---------------------------------------------
  const formatSend = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>เพิ่มสิทธิย่อยใหม่</Tooltip>}
        >
          <BtnSend
            onClick={() => {
              insertNewRight(row);
            }}
          >
            <AiOutlinePlus style={{ marginLeft: "-8px", marginTop: "-18px" }} />
          </BtnSend>
        </OverlayTrigger>
      </div>
    );
  };
  // ---------------------------------------------
  const formatRtn = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>เอาออก</Tooltip>}
        >
          <BtnSend
            variant="danger"
            onClick={() => {
              actionDelete(row);
            }}
          >
            <AiOutlineMinus
              style={{ marginLeft: "-8px", marginTop: "-18px" }}
            />
          </BtnSend>
        </OverlayTrigger>
      </div>
    );
  };
  // --------------------- COLUMN ------------------------------
  const colGoodMain = [
    {
      dataField: "patrightcode",
      text: "รหัสสิทธิ",
      sort: true,
      headerStyle: () => getHeaderStyle("120px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "patrightname",
      text: "ชื่อสิทธิรักษา",
      sort: true,
      headerStyle: () => getHeaderStyle("auto"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "none",
      text: "-",
      headerStyle: () => getHeaderStyle("40px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "center",
      },
      formatter: formatSend,
    },
  ];

  // --------------------- BRANCH COLUMN -------------------------
  const colGoodBranch = [
    {
      dataField: "brchpatrightcode",
      text: "รหัส",
      sort: true,
      headerStyle: () => getHeaderStyle("120px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
      },
      filter: textFilter(customTextFilter),
      editable: true,
    },
    {
      dataField: "brchpatrightname",
      text: "ชื่อสิทธิรักษาสาขา",
      sort: true,
      headerStyle: () => getHeaderStyle("auto"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
      },
      filter: textFilter(customTextFilter),
      editable: true,
    },
    {
      dataField: "none",
      text: "-",
      headerStyle: () => getHeaderStyle("40px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "center",
      },
      formatter: formatRtn,
      editable: false,
    },
  ];

  //------------  Save ราคา  --------------------------------------------------
  const actionBeforeSave = async (oldValue, newValue, row, column, done) => {
    setRowsEdited(
      (pv) => pv && pv.filter((r) => r.brchpatrightid !== row.brchpatrightid)
    );
    setRowsEdited((old) => (old ? [...old, row] : row));
    setShowSaveOk(true);
  };
  useEffect(() => {
    // console.log(rowsEdited);
    // refresh updated items
  }, [rowsEdited]);
  //--------------------  Update สิทธิ ------------------------------------
  const UpdateBatch = (goReady) => {
    axios
      .post(
        process.env.REACT_APP_API + "api/branch-patient-right/update-batch",
        {
          UserInfo: userDetail,
          ItemsInfo: rowsEdited,
        },
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(
          setReminder({
            show: true,
            message: "ปรับปรุงสมบูรณ์",
            type: "success",
          })
        );
        setShowSaveOk(false);
        setRowsEdited([]);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  // -------------------  Update สิทธิ ------------------------------------
  const actionDelete = (row) => {
    setShowConfirm(true);
    setConfirmAction({
      title: GetConfirmTitle("DELETE"),
      data: row,
      action: (row) => {
        axios
          .post(
            process.env.REACT_APP_API +
              "api/branch-patient-right/remove-single-right",
            {
              ItemInfo: row,
              UserInfo: userDetail,
            },
            HttpJsonHeader
          )
          .then((res) => {
            refreshBranchRight(selectedMain);
            dispatch(
              setReminder({
                show: true,
                message: "ยกเลิกสมบูรณ์",
                type: "success",
              })
            );
          })
          .catch((err) => {
            dispatch(
              setReminder({ show: true, message: err.message, type: "error" })
            );
          });
      },
    });
  };
  // --------------------- RENDER ------------------------------
  return (
    <div className="tab-content-worklist center-box-new">
      <HBox>
        <VBox>
          <div class="patient-right-item-wrapper ">
            <div class="table-caption-box-right-flex">สิทธิรักษาหลัก</div>

            {GetCreateTable({
              idFieldName: "patrightid",
              columns: colGoodMain,
              data: mainright,
              // cellEdit: cellEditFactory({
              //   mode: "click",
              //   blurToSave: true,
              //   beforeSaveCell: actionBeforeSave,
              // }),
              disablePagination: true,
              rowEvents: {
                onClick: (e, row, rowIndex) => {
                  refreshBranchRight(row);
                },
              },
            })}

            {/* <BoostrapTable
              bootstrap4
              keyField="patrightid"
              rowClasses={"table-next-rows-style"}
              data={mainright}
              columns={colGoodMain}
              striped
              hover
              condensed
              headerWrapperClasses="headerWrapper"
              wrapperClasses="bs-table-wrapper"
              bordered={true}
              pagination={paginationFactory(PageOptionsPvNx)}
              filter={filterFactory()}
              rowEvents={{
                onClick: (e, row, rowIndex) => {
                  refreshBranchRight(row);
                },
              }}
            /> */}
          </div>
        </VBox>

        <VBox>
          <div class="patient-right-item-wrapper ">
            <div class="table-caption-box-right-flex">
              ชื่อสิทธิรักษาย่อยของกลุ่มสิทธิ
              <span style={{ color: "#e5f507", paddingInline: "5px" }}>
                {selectedMain &&
                  selectedMain.patrightname &&
                  selectedMain.patrightname}
              </span>
            </div>

            {GetCreateTable({
              idFieldName: "brchpatrightid",
              columns: colGoodBranch,
              data: brchright,
              cellEdit: cellEditFactory({
                mode: "click",
                blurToSave: true,
                beforeSaveCell: actionBeforeSave,
              }),
            })}

            {/* <BoostrapTable
                bootstrap4 keyField='brchpatrightid' 
                rowClasses={'table-next-rows-style'}
                data={brchright}  
                columns={colGoodBranch} 
                striped  hover condensed             
                headerWrapperClasses = "headerWrapper" 
                wrapperClasses="bs-table-wrapper"                                        
                bordered={ true }       
                pagination = {paginationFactory( PageOptionsPvNx)}  
                filter={ filterFactory() }   
                cellEdit={cellEditFactory({                            
                  mode:'click', 
                  blurToSave: true,                  
                  beforeSaveCell:actionBeforeSave
                  })}              
              />   */}
          </div>
          <ConfirmBox show={showSaveOk}>
            <Button
              style={{ marginRight: "10px" }}
              onClick={() => UpdateBatch()}
            >
              <AiOutlineCheck style={{ marginRight: "5px" }} />
              Confirm
            </Button>

            <Button
              variant="danger"
              onClick={() => {
                setRowsEdited([]);
                setShowSaveOk(false);
              }}
            >
              Cancel
            </Button>
          </ConfirmBox>
        </VBox>
      </HBox>
      <ConfirmDialog
        {...{ showConfirm, setShowConfirm, confirmAction, setConfirmAction }}
      />
    </div>
  );
}

const HBox = styled.div`
  flex: 1;
  display: flex;
`;

const VBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  /* background-color: red; */
`;

const BtnSend = styled(Button)`
  width: 18px;
  height: 25px;
  border-radius: 20px 20px 20px 20px;
  &:hover {
    background-color: yellow;
    color: black;
    transform: rotate((20deg));
  }
`;

const TableLabel = styled.div`
  color: var(--caption-fore-color);
  margin: 10px 10px 0px 10px;
`;

const ConfirmBox = styled.div`
  position: absolute;
  bottom: auto;
  top: 150px;
  right: 0px;
  margin-right: 50px;
  padding-inline: 120px;
  padding-block: 15px;
  border-radius: 5px 5px 5px 5px;
  /* background-color: #ffffff; */
  background: #404241;
  box-shadow: 10px 10px 10px #7e7878;

  ${(props) => {
    if (props.show) {
      return ` 
            visibility: visible;        
            transition: 0.3s ease-in;
            opacity: 1;
            right: 200px;                   
          `;
    } else {
      return ` 
            visibility: hidden;            
            transition: 0.7s ease-out;  
            opacity : 0;
            right:-150px;
          `;
    }
  }}
`;
